import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin( ScrollToPlugin );

export class TableOfContents {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.options = options;
		this.allHeading = [];
		this.isEnable = false;
		this.init();
	}
	init() {
		if ( this.isEnable ) return;
		if ( ! this.elements?.length ) return;
		const firstLevel = this.options.firstLevel || 'h2';
		const secondLevel = this.options.secondLevel || 'h3';
		this.allHeading = document.querySelectorAll(
			`${ firstLevel }, ${ secondLevel }`
		);
		// 包含的类名
		const includeClass = this.options.include || [];
		if ( includeClass.length > 0 ) {
			const filteredHeadings = [];
			this.allHeading.forEach( ( heading ) => {
				const hasMatchingClass = includeClass.some( ( className ) =>
					heading.classList.contains( className.slice( 1 ) )
				);
				if ( hasMatchingClass ) {
					filteredHeadings.push( heading );
				}
			} );
			this.allHeading = filteredHeadings;
		}
		// 排除的类名
		const excludeClass = this.options.exclude || [];
		if ( excludeClass.length > 0 ) {
			const filteredHeadings = [];
			this.allHeading.forEach( ( heading ) => {
				const hasMatchingClass = excludeClass.some( ( className ) =>
					heading.classList.contains( className.slice( 1 ) )
				);
				if ( ! hasMatchingClass ) {
					filteredHeadings.push( heading );
				}
			} );
			this.allHeading = filteredHeadings;
		}
		const theArray = this.generateArray( this.allHeading );
		const theHTML = this.createHTML( theArray );
		this.elements.forEach( ( container ) => {
			this.append( container, theHTML );
		} );
		this.isEnable = true;
	}

	append( container, theHTML ) {
		const wrapper = container.querySelector( '.el-menu-body' );
		wrapper.appendChild( theHTML );
		const theButtons = wrapper.querySelectorAll( '.el-menu-item-link' );
		theButtons.forEach( ( button, index ) => {
			button.addEventListener( 'click', () => {
				const theEle = this.allHeading[ index ];
				gsap.to( window, {
					scrollTo: theEle,
					duration: 0.5,
					ease: 'power2.inOut',
				} );
			} );
		} );
	}

	createHTML( data ) {
		const ulElement = document.createElement( 'ul' );
		ulElement.classList.add( 'el-menu-list' );

		data.forEach( ( item ) => {
			const liElement = document.createElement( 'li' );
			liElement.classList.add( 'el-menu-item' );

			const divElement = document.createElement( 'div' );
			divElement.classList.add( 'el-menu-item-link' );

			const spanElement = document.createElement( 'span' );
			spanElement.textContent = item.text;

			divElement.appendChild( spanElement );
			liElement.appendChild( divElement );

			if ( item.children && item.children.length > 0 ) {
				const childList = document.createElement( 'ul' );
				childList.classList.add( 'el-sub-menu-list' );

				item.children.forEach( ( childItem ) => {
					const childLiElement = document.createElement( 'li' );
					childLiElement.classList.add( 'el-menu-item' );

					const childDivElement = document.createElement( 'div' );
					childDivElement.classList.add( 'el-menu-item-link' );

					const childSpanElement = document.createElement( 'span' );
					childSpanElement.textContent = childItem.text;

					childDivElement.appendChild( childSpanElement );
					childLiElement.appendChild( childDivElement );
					childList.appendChild( childLiElement );
				} );

				liElement.appendChild( childList );
			}

			ulElement.appendChild( liElement );
		} );

		return ulElement;
	}

	generateArray( theElements ) {
		if ( ! theElements?.length ) return [];
		const theArray = [];
		theElements.forEach( ( element ) => {
			theArray.push( {
				tagName: element.tagName.toLowerCase(),
				text: element.innerText,
			} );
		} );
		const resultArray = [];
		let currentH2;
		theArray.forEach( ( item ) => {
			if ( item.tagName === 'h2' ) {
				currentH2 = { ...item, children: [] };
				resultArray.push( currentH2 );
			} else if ( item.tagName === 'h3' && currentH2 ) {
				currentH2.children.push( item );
			}
		} );
		return resultArray;
	}
}
